import { tafRequest } from 'amkit3-modules/utils/taf';
import GetVideoLiveBarrage from 'amkit3-modules/utils/taf/jce/GetVideoLiveBarrage';

export const getVideoLiveBarrage = (data) =>
  tafRequest({
    data,
    funcName: 'getVideoLiveBarrage',
    reqClass: GetVideoLiveBarrage.GetVideoLiveBarrageReq,
    rspClass: GetVideoLiveBarrage.GetVideoLiveBarrageRsp,
  });
